import React from 'react';
import { reaction } from 'mobx';
import { webSocketStore } from 'store/notification';
import { stompClient } from 'lib/webSocket';
import {
  default as notification,
  IconType,
  NotificationPlacement,
} from 'components/public-components/customized-notification';
import * as Cookies from 'js-cookie';

const key = 'GLOBAL_NOTIFICATION';

export const Notification = React.memo((props: {}) => {
  React.useEffect(() => {
    stompClient.activate();
    return () => {
      stompClient.deactivate();
      notification.close(key);
    };
  }, []);
  React.useEffect(() => {
    const disposer = reaction(
      () => webSocketStore.approvedByMeCount,
      () => {
        if (webSocketStore.approvedByMeCount !== '') {
          const type: IconType = 'success';
          const placement: NotificationPlacement = 'center';
          const args = {
            description: webSocketStore.approvedByMeCount,
            duration: 5,
            type,
            placement,
          };
          notification.open(args);
        }
      },
      { fireImmediately: true },
    );
    return disposer;
  }, []);
  return null;
});
